import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import {
  colors,
  VStack,
  responsive,
  Image,
  getCdnImageSrc,
  HStack,
  ColorIcon,
  VLine,
} from "goi_common";
import React, { useState } from "react";
import SlideBase from "react-slick";

export default function DisposalListSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.white}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 0px",
            lg: "120px 0px",
          },
        })}
      >
        <DesktopList />
        <MobileList />
      </VStack>
    </VStack>
  );
}

function DesktopList() {
  return (
    <VStack className="lg_under_hidden" gap="50px">
      {" "}
      <VStack gap="10px">
        <HStack
          gap="10px"
          css={responsive({
            width: "fit-content",
            padding: "10px 20px",
            background: colors.warmGray200,
            fontSize: "22px",
            fontWeight: "bold",
            color: colors.warmGray700,
            borderRadius: "10px",
          })}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={getCdnImageSrc("b2b/disposal/cup.png")}
            alt=""
            width="22px"
          />
          <Box>접시/컵류</Box>
        </HStack>
        <VLine width="100%" height="1px" color={colors.gray300} />
      </VStack>
      <HStack gap="20px">
        <TableItem
          imageSrc="disposal-1.png"
          상품="국/밥그릇"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-2.png"
          상품="음료컵"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-3.png"
          상품="소주컵"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
      </HStack>
      <HStack gap="20px">
        <TableItem
          imageSrc="disposal-4.png"
          상품="친환경 소재 접시 (대)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-5.png"
          상품="친환경 소재 접시 (중)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-6.png"
          상품="친환경 소재 접시 (소)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
      </HStack>
      <VStack gap="10px">
        <HStack
          gap="10px"
          css={responsive({
            width: "fit-content",
            padding: "10px 20px",
            background: colors.warmGray200,
            fontSize: "22px",
            fontWeight: "bold",
            color: colors.warmGray700,
            borderRadius: "10px",
          })}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={getCdnImageSrc("b2b/disposal/spoon.png")}
            alt=""
            width="22px"
          />
          <Box>수저</Box>
        </HStack>
        <VLine width="100%" height="1px" color={colors.gray300} />
      </VStack>
      <TableHorizontalItem
        imageSrc="disposal-7.png"
        상품="숟가락"
        재질="PP(폴리프로필렌)"
        인쇄방식="규정 CI 인쇄 1도"
      />
      <TableHorizontalItem
        imageSrc="disposal-8.png"
        상품="젓가락"
        재질="대나무"
        인쇄방식="규정 CI 인쇄 1도"
      />
      <VStack gap="10px">
        <HStack
          gap="10px"
          css={responsive({
            width: "fit-content",
            padding: "10px 20px",
            background: colors.warmGray200,
            fontSize: "22px",
            fontWeight: "bold",
            color: colors.warmGray700,
            borderRadius: "10px",
          })}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            src={getCdnImageSrc("b2b/disposal/box.png")}
            alt=""
            width="22px"
          />
          <Box>박스</Box>
        </HStack>
        <VLine width="100%" height="1px" color={colors.gray300} />
      </VStack>
      <TableHorizontalItem
        imageSrc="disposal-9.png"
        상품="수저통"
        재질="고급합지, OPP필름"
        인쇄방식="규정 CI 인쇄 1도"
      />
      <TableHorizontalItem
        imageSrc="disposal-10.png"
        상품="포장박스"
        재질="KLB 고급 수출용"
        인쇄방식="규정 CI 인쇄 1도"
      />
    </VStack>
  );
}

function MobileList() {
  const [, setBeforeCount] = useState(0);
  return (
    <VStack
      className="lg_over_hidden"
      width="100vw"
      overflow="hidden"
      position="relative"
    >
      <Slide
        initialSlide={0}
        beforeChange={(_, next) => setBeforeCount(next)}
        arrows={true}
        centerMode={true}
        infinite={true}
        variableWidth={true}
        autoplay={true}
        speed={1000}
        nextArrow={
          <Box
            width="36px !important"
            height="36px !important"
            backgroundColor="white"
            borderRadius="36px"
            padding="3px 5px"
            boxShadow="0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
          >
            <ColorIcon
              name="arrow_right_small"
              size={30}
              color={colors.gray900}
            />
          </Box>
        }
        prevArrow={
          <Box
            width="36px !important"
            height="36px !important"
            backgroundColor="white"
            borderRadius="36px"
            padding="3px 1px"
            boxShadow="0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
          >
            <ColorIcon
              name="arrow_left_small"
              size={30}
              color={colors.gray900}
            />
          </Box>
        }
      >
        <TableItem
          imageSrc="disposal-1.png"
          상품="국/밥그릇"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-2.png"
          상품="음료컵"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-3.png"
          상품="소주컵"
          재질="무형광 펄프 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-4.png"
          상품="친환경 소재 접시 (대)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-5.png"
          상품="친환경 소재 접시 (중)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-6.png"
          상품="친환경 소재 접시 (소)"
          재질="친환경 소재 사용"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-7.png"
          상품="숟가락"
          재질="PP(폴리프로필렌)"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-8.png"
          상품="젓가락"
          재질="대나무"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-9.png"
          상품="수저통"
          재질="고급합지, OPP필름"
          인쇄방식="규정 CI 인쇄 1도"
        />
        <TableItem
          imageSrc="disposal-10.png"
          상품="포장박스"
          재질="KLB 고급 수출용"
          인쇄방식="규정 CI 인쇄 1도"
        />
      </Slide>
    </VStack>
  );
}

const Slide = styled(SlideBase)`
  padding: 10px 0px;
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    padding: 0 8px;
  }
  .slick-list {
    margin: 0 -8px;
  }

  .slick-arrow {
    position: absolute;
    top: 199px;
    width: 14px;
    height: 25px;
    font-size: 0;
    z-index: 10;
  }

  .slick-prev {
    left: 20px;
  }

  .slick-next {
    right: 20px;
  }
`;

function TableItem({
  imageSrc,
  상품,
  재질,
  인쇄방식,
}: {
  imageSrc: string;
  상품: string;
  재질: string;
  인쇄방식: string;
}) {
  return (
    <VStack gap="20px">
      <Box
        css={responsive({
          width: { base: "300px", lg: "340px" },
          height: { base: "235px", lg: "auto" },

          verticalAlign: "bottom",
        })}
      >
        <Image src={getCdnImageSrc(`b2b/disposal/${imageSrc}`)} alt="" />
      </Box>

      <VStack>
        <ListItem title="상품" name={상품} />
        <ListItem title="재질" name={재질} />
        <ListItem title="인쇄방식" name={인쇄방식} />
      </VStack>
    </VStack>
  );
}

function TableHorizontalItem({
  imageSrc,
  상품,
  재질,
  인쇄방식,
}: {
  imageSrc: string;
  상품: string;
  재질: string;
  인쇄방식: string;
}) {
  return (
    <HStack gap="20px" alignItems="flex-end">
      <Box css={responsive({ width: { base: "300px", lg: "700px" } })}>
        <Image src={getCdnImageSrc(`b2b/disposal/${imageSrc}`)} alt="" />
      </Box>

      <VStack>
        <ListItem title="상품" name={상품} />
        <ListItem title="재질" name={재질} />
        <ListItem title="인쇄방식" name={인쇄방식} />
      </VStack>
    </HStack>
  );
}

function ListItem({ title, name }: { title: string; name: string }) {
  return (
    <VStack
      width="100%"
      css={{
        borderBottom:
          title === "상품"
            ? `1px solid ${colors.warmGray700}`
            : `1px solid ${colors.gray300}`,
      }}
    >
      <HStack>
        <Box
          css={responsive({ width: { base: "100px", lg: "110px" } })}
          textAlign="center"
          lineHeight="60px"
          background={colors.gray900}
          className={
            title === "상품" ? "white subtitle_18_b" : "white body_18_r"
          }
        >
          {title}
        </Box>
        <Box
          css={responsive({
            padding: "17px 0",
            width: { base: "200px", lg: "230px" },
            textAlign: "center",
          })}
          background={title === "상품" ? colors.brown150 : colors.white}
          color={title === "상품" ? colors.brown600 : colors.gray900}
          className={title === "상품" ? "subtitle_18_b" : "body_18_r"}
        >
          {name}
        </Box>
      </HStack>
    </VStack>
  );
}
